<div class="eb-wrap">
  <ng-container *ngIf="aktiv.ugyfelId; else nincsUgyfel">
    <section class="eb-kartya">
      <!-- Fejléc -->
      <header class="eb-fej">
        <div class="eb-fej-ikon"><ion-icon name="rocket-outline"></ion-icon></div>
        <div class="eb-fej-szoveg">
          <h1>Első beállítás</h1>
          <p *ngIf="aktiv.ugyfelNev">{{ aktiv.ugyfelNev }} &middot; {{ aktiv.ev }}. év</p>
        </div>
        <button type="button" class="eb-frissit" (click)="allapotFrissit()" [disabled]="loading" title="Állapot frissítése">
          <ion-icon name="refresh-outline" [class.forog]="loading"></ion-icon>
        </button>
      </header>

      <!-- Haladás -->
      <div class="eb-halado">
        <div class="eb-halado-fej">
          <span class="eb-halado-cim" [class.kesz]="mindKesz">
            <ion-icon *ngIf="mindKesz" name="checkmark-circle"></ion-icon>
            {{ mindKesz ? 'Minden lépés elkészült' : 'A könyvelés indításához' }}
          </span>
          <span class="eb-halado-szam">{{ keszSzam }}<small>/{{ osszesSzam }}</small></span>
        </div>
        <div class="eb-sav"><div class="eb-sav-kitolt" [class.kesz]="mindKesz" [style.width.%]="keszArany * 100"></div></div>
      </div>

      <!-- Lépések -->
      <ol class="eb-lepesek">
        <li *ngFor="let lepes of lepesek; let i = index" class="eb-lepes"
            [class.kesz]="lepes.kesz === true"
            [class.hianyzik]="lepes.kesz === false"
            [class.ismeretlen]="lepes.kesz === null">
          <div class="eb-allapot" [attr.aria-label]="lepes.kesz === true ? 'kész' : (lepes.kesz === false ? 'hiányzik' : 'ellenőrzés')">
            <ion-icon *ngIf="lepes.kesz === true" name="checkmark-outline"></ion-icon>
            <ion-icon *ngIf="lepes.kesz === null" name="ellipsis-horizontal" class="forog-lassu"></ion-icon>
            <span *ngIf="lepes.kesz === false">{{ i + 1 }}</span>
          </div>

          <div class="eb-torzs">
            <div class="eb-cim-sor">
              <ion-icon [name]="lepes.ikon" class="eb-lepes-ikon"></ion-icon>
              <span class="eb-cim">{{ lepes.cim }}</span>
              <span class="eb-pill"
                    [class.p-kesz]="lepes.kesz === true"
                    [class.p-hianyzik]="lepes.kesz === false"
                    [ngSwitch]="lepes.kesz">
                <ng-container *ngSwitchCase="true">Kész</ng-container>
                <ng-container *ngSwitchCase="false">Hiányzik</ng-container>
                <ng-container *ngSwitchDefault>Ellenőrzés…</ng-container>
              </span>
            </div>
            <p class="eb-leiras">{{ lepes.leiras }}</p>
          </div>

          <button type="button" class="eb-gomb" [class.masodlagos]="lepes.kesz === true" (click)="beallit(lepes)">
            {{ lepes.kesz === true ? 'Megnézem' : 'Beállítás' }}
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </button>
        </li>
      </ol>
    </section>
  </ng-container>

  <ng-template #nincsUgyfel>
    <section class="eb-kartya eb-ures">
      <div class="eb-fej-ikon nagy"><ion-icon name="rocket-outline"></ion-icon></div>
      <h1>Első beállítás</h1>
      <p>Válassz ügyfelet a beállítás megkezdéséhez.</p>
    </section>
  </ng-template>
</div>
